import { render, staticRenderFns } from "./form_assignment_individual_component.vue?vue&type=template&id=5f33518c&scoped=true"
import script from "./form_assignment_individual_component.vue?vue&type=script&lang=js"
export * from "./form_assignment_individual_component.vue?vue&type=script&lang=js"
import style0 from "./form_assignment_individual_component.vue?vue&type=style&index=0&id=5f33518c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33518c",
  null
  
)

export default component.exports